import { Check } from '@/util/checkValue/CheckValue.js';
import _this from '@/main.js'
/**
 * 验证试题是否已答
 * 
 */
export const Verification = (list) => {
    let inputTypeArr = ['2', '3', '4', '5', '35']; // 部分填空类需要验证格式
    let singleTypeArr = ['8', '12', '9', '13', '15', '17', '38']; // 单选类 、不需要验证格式
    let result = false;
    let goAnchorName = ''
    for (let i in list) {
        // 试题隐藏 则不做验证
        if (!list[i].isShow || !list[i].bindIsShow) {
            continue;
        }
        if (list[i].questionsTypeId == '8' || list[i].questionsTypeId == '10' || list[i].questionsTypeId == '14') {
            // 选项后的'其他'填空验证
            console.log('list[i] :>> ', list[i]);
            for(let j in list[i].optionList) {
                if (list[i].optionList[j].notAnswer && list[i].optionList[j].inputValue == ''){
                    continue;
                }
                if (list[i].optionList[j].haveInput) {
                    if ((list[i].questionsTypeId == '8' && list[i].userAnswer == list[i].optionList[j].oid)||
                        (list[i].questionsTypeId == '10' || list[i].questionsTypeId == '14') && list[i].userAnswerArr.indexOf(list[i].optionList[j].oid) != -1
                    ) {
                        console.log('list[i].optionList[j] :>> ', list[i].optionList[j]);
                        if (list[i].optionList[j].inputValue == '' && !list[i].optionList[j].notAnswer) {
                            list[i].validateMsg = _this.$t('UserAnswer.InputContent')
                            list[i].validate = true;
                            result = true
                        } else {
                            list[i].optionList[j].userAnswer = list[i].optionList[j].inputValue
                            result = Check(list[i].optionList[j],list[i]);
                        }
                        // console.log('result :>> ', result);
                        if (result) {
                            console.log('list[i] :>> ', list[i]);
                            goAnchorName = `name${list[i].qid}`
                            return {
                                result,
                                goAnchorName
                            };
                        }
                    }
                }
            }
        }
        if (list[i].mustanswer) {
            if (list[i].questionsTypeId == '33') {
                if (list[i].userAnswerArr.length == 0) {
                    list[i].validate = true;
                    goAnchorName = `name${list[i].qid}`
                    result = true;
                    break;
                } else {
                    list[i].validate = false;
                }
            } else if (list[i].questionsTypeId == '36') {
                if (list[i].optionValue.length == 0) {
                    list[i].validate = true;
                    list[i].validateMsg = _this.$t('UserAnswer.SelectCascadingOption');
                    goAnchorName = `name${list[i].qid}`
                    result = true;
                    break;
                } else {
                    list[i].validate = false;
                }
            } else if (list[i].questionsTypeId == '35' || list[i].questionsTypeId == '34') {
                // console.log('判断对了')
                list[i].optionList.forEach((info) => {
                    info.validate = false
                })
                for (let j in list[i].optionList) {
                    if ((list[i].optionList[j].mustanswer && list[i].questionsTypeId == '34') || (!list[i].optionList[j].notAnswer && list[i].questionsTypeId == '35')) {
                        if (list[i].optionList[j].userAnswer == '') {
                            list[i].optionList[j].validate = true;
                            list[i].optionList[j].validateMsg = _this.$t('UserAnswer.InputContent');
                            goAnchorName = `name${list[i].qid}`
                            result = true;
                            return {
                                result,
                                goAnchorName
                            };
                        } else {
                            // console.log('list[i].optionList[j].format  :>> ', list[i].optionList[j].format );
                            result = Check(list[i].optionList[j]);
                            // console.warn('result :>> ', result);
                            if (result) {
                                goAnchorName = `name${list[i].qid}`
                                return {
                                    result,
                                    goAnchorName
                                };
                            }
                        }
                    } else {
                        if (list[i].optionList[j].userAnswer != '') {
                            result = Check(list[i].optionList[j]);
                            if (result) {
                                goAnchorName = `name${list[i].qid}`
                                return {
                                    result,
                                    goAnchorName
                                };
                            }
                        } else {
                            list[i].optionList[j].validate = false;
                        }
                    }
                }
            } else if (list[i].questionsTypeId == '37') {
                let newArr = list[i].optionList.filter(item => item.userAnswer > 0);
                if (newArr.length == 0) {
                    list[i].validate = true;
                    goAnchorName = `name${list[i].qid}`
                    result = true;
                    break;
                } else {
                    list[i].validate = false;
                }
            } else if (inputTypeArr.indexOf(list[i].questionsTypeId) !== -1) {
                // 简单输入类题型
                if (list[i].userAnswer == '') {
                    list[i].validate = true;
                    list[i].validateMsg = _this.$t('UserAnswer.InputContent');
                    goAnchorName = `name${list[i].qid}`
                    result = true;
                    break;
                } else {
                    result = Check(list[i]);
                    if (result) {
                        goAnchorName = `name${list[i].qid}`
                        break;
                    }
                }
            } else if (singleTypeArr.indexOf(list[i].questionsTypeId) !== -1) {
                if ((!list[i].userAnswer && list[i].questionsTypeId != '38') || (list[i].userAnswer == -1 && list[i].questionsTypeId == '38')) {
                    list[i].validate = true;
                    goAnchorName = `name${list[i].qid}`
                    result = true;
                    break;
                } else {
                    list[i].validate = false;
                }
            } else if (list[i].questionsTypeId == '11') {
                if (list[i].userAnswer == -1) {
                    list[i].validate = true;
                    goAnchorName = `name${list[i].qid}`
                    result = true;
                    break;
                } else {
                    list[i].validate = false;
                }
            } else if (list[i].questionsTypeId == '14') {
                // console.log(list[i].userAnswerArr)
                if (list[i].userAnswerArr.length == 0 || list[i].userAnswerArr.length < list[i].sortsnums) {
                    list[i].validate = true;
                    goAnchorName = `name${list[i].qid}`
                    result = true;
                    break;
                } else {
                    list[i].validate = false;
                }
            } else if (list[i].questionsTypeId == '6' || list[i].questionsTypeId == '10') {
                // 选择图片 有单选、多选形式
                if (list[i].cutType == 8 || list[i].questionsTypeId == '10') {
                    if (list[i].userAnswerArr.length == 0) {
                        list[i].validate = true;
                        if (list[i].questionsTypeId == '6') {
                            list[i].validateMsg = _this.$t('UserAnswer.SelectTheFollowingImage');
                        } else {
                            list[i].validateMsg = _this.$t('UserAnswer.SelectOptions');
                        }
                        goAnchorName = `name${list[i].qid}`
                        result = true;
                        break;
                    } else {
                        if (list[i].userAnswerArr.length < list[i].minOptionsNum) {
                            list[i].validateMsg = `${_this.$t('UserAnswer.MinimalSelection')}${list[i].minOptionsNum}${_this.$t('UserAnswer.Options')}`;
                            list[i].validate = true;
                            goAnchorName = `name${list[i].qid}`
                            result = true;
                            break;
                        } else {
                            list[i].validate = false;
                        }
                    }
                } else {
                    if (list[i].userAnswer == '') {
                        list[i].validate = true;
                        goAnchorName = `name${list[i].qid}`
                        result = true;
                        break;
                    } else {
                        list[i].validate = false;
                    }
                }
            } else if (list[i].questionsTypeId == '16') {
                if (list[i].userAnswerArr.length == 0 || list[i].userAnswerArr.length < list[i].choiceRange) {
                    list[i].validate = true;
                    goAnchorName = `name${list[i].qid}`
                    result = true;
                    break;
                } else {
                    list[i].validate = false;
                }
            } else if (list[i].questionsTypeId == '19' || list[i].questionsTypeId == '21') {
                let answer = false;
                if (list[i].userAnswerArr.length == 0) {
                    answer = true;
                }
                list[i].userAnswerArr.forEach((info, uindex) => {
                    if (list[i].questionsTypeId == '19') {
                        if (!info.value) {
                            answer = true;
                            list[i].validateMsg = `请检查答案`;
                        } else {
                            for (let j in list[i].questionsSonList) {
                                for (let k in list[i].questionsSonList[j].optionList) {
                                    let op = list[i].questionsSonList[j].optionList[k] 
                                    op.validate = false
                                    if (info.value.indexOf(':') !== -1) {
                                        if (op.oid == info.value.split(':')[0] && uindex == j) {
                                            op.userAnswer = info.value.split(':')[1];
                                            result = Check(op, list[i]);
                                            if (result) {
                                                goAnchorName = `name${list[i].qid}`
                                                answer = result;
                                                return {
                                                    result,
                                                    goAnchorName
                                                };
                                            }
                                        }
                                    } else if (info.value.indexOf(op.oid) != -1 && uindex == j && info.value.indexOf(':') == -1 && op.notAnswer == false) {
                                        answer = true;
                                        op.validate = true;
                                        list[i].validateMsg = `请检查答案`;
                                        goAnchorName = `name${list[i].qid}`
                                        result = true
                                        return {
                                            result,
                                            goAnchorName
                                        };
                                    }
                                }
                            } 
                        }
                    } else if (list[i].questionsTypeId == '21') {
                        if (!info.optionValue) {
                            answer = true;
                        } else {
                            info.optionValue.forEach(el => {
                                if (el.value < 1) answer = true;
                            });
                        }
                    }
                });
                if (answer) {
                    list[i].validate = true;
                    goAnchorName = `name${list[i].qid}`
                    result = true;
                    return {
                        result,
                        goAnchorName
                    };
                } else {
                    list[i].validate = false;
                }
            } else if (list[i].questionsTypeId == '20') {
                let answer = false;
                if (list[i].userAnswerArr.length == 0) {
                    answer = true;
                }
                list[i].userAnswerArr.forEach((info,uindex) => {
                    if (info.value) {
                        let arr = info.value.split(',');
                        if (arr.length < list[i].minOptionsNum || (list[i].maxOptionsNum != 0 && arr.length > list[i].maxOptionsNum)) {
                            list[i].validateMsg = `${_this.$t('UserAnswer.CheckTheAnswers')},${_this.$t('UserAnswer.MinimalSelection')}${list[i].minOptionsNum}${_this.$t('UserAnswer.MaximumSelection')},${_this.$t('UserAnswer.Options')}${list[i].maxOptionsNum}${_this.$t('UserAnswer.Options')}`;
                            answer = true;
                        }
                        for (let j in list[i].questionsSonList) {
                            if (uindex == j) {
                                for (let k in list[i].questionsSonList[j].optionList) {
                                    let op = list[i].questionsSonList[j].optionList[k]
                                    op.validate = false
                                    for (let g in arr) {
                                        if (arr[g].indexOf(':') !== -1) {
                                            if (op.oid == arr[g].split(':')[0]) {
                                                op.userAnswer = arr[g].split(':')[1];
                                                result = Check(op, list[i]);
                                                if (result) {
                                                    answer = true;
                                                    goAnchorName = `name${list[i].qid}`
                                                    return {
                                                        result,
                                                        goAnchorName
                                                    };
                                                }
                                            }
                                        } else if (arr[g].indexOf(':') == -1 &&  info.value.indexOf(op.oid) != -1 && op.notAnswer == false && op.haveInput == true && op.inputValue == '') {
                                            answer = true;
                                            list[i].validateMsg = `请检查答案`;
                                            op.validate = true
                                            goAnchorName = `name${list[i].qid}`
                                            result = true
                                            return {
                                                result,
                                                goAnchorName
                                            };
                                        }
                                    }
                                }
                            }
                        }
                    } else {
                        answer = true;
                        list[i].validateMsg = `请检查答案`;
                    }
                });
                if (answer) {
                    list[i].validate = true;
                    goAnchorName = `name${list[i].qid}`
                    result = true;
                    return {
                        result,
                        goAnchorName
                    };
                } else {
                    list[i].validate = false;
                }
            } else if (list[i].questionsTypeId == '22') {
                for (let j in list[i].questionsSonList) {
                    for (let k in list[i].questionsSonList[j].optionList) {
                        let op = list[i].questionsSonList[j].optionList[k]
                        if (op.userAnswer == '' && op.notAnswer == false) {
                            list[i].validateMsg = '请输入内容'
                            list[i].validate = true;
                            op.validateMsg = '请输入内容'
                            op.validate = true;
                            goAnchorName = `name${list[i].qid}`
                            result = true
                            return {
                                result,
                                goAnchorName
                            };
                        } else if (op.userAnswer && op.userAnswer != '') {
                            result = Check(op, list[i]);
                            // console.warn('result :>> ', result);
                            if (result) {
                                goAnchorName = `name${list[i].qid}`
                                return {
                                    result,
                                    goAnchorName
                                };
                            } else {
                                list[i].validate = false;
                                op.validate = false;
                            }
                        } else {
                            list[i].validate = false;
                            op.validate = false;
                        }
                    }
                }
            } else if (list[i].questionsTypeId == '39') {
                // debugger
                let answer = false;
                if (list[i].userAnswerArr.length == 0) {
                    answer = true;
                }
                try {
                    list[i].userAnswerArr.forEach((info, userI) => {
                        if (!info.optionValue) {
                            answer = true;
                            throw Error();
                        } else {
                            info.optionValue.forEach(op => {
                                if (op.value == '' && list[i].questionsSonList[userI].disable){
                                    answer = false;
                                } else {
                                    list[i].questionsSonList.forEach(el => {
                                        el.optionList.forEach(obj => {
                                            if (obj.notAnswer == false) {
                                                if (op.value) {
                                                    if (
                                                        obj.type == '6' ||
                                                        obj.type == '3' ||
                                                        obj.type == '24' ||
                                                        obj.type == '22' ||
                                                        obj.type == '23' ||
                                                        obj.type == '9' ||
                                                        obj.type == '18' ||
                                                        obj.type == '19'
                                                    ) {
                                                        obj.format = Transition(obj);
                                                        let str = Check(obj, list[i]);
                                                        if (str) {
                                                            list[i].validateMsg = obj.validateMsg;
                                                            goAnchorName = `name${list[i].qid}`
                                                            answer = str;
                                                            throw Error();
                                                        }else{
                                                            answer = str;
                                                        }
                                                    }
                                                } else {
                                                    if (el.type == '26' && el.userAnswer || (el.disable)){
                                                        answer = false;
                                                    } else {
                                                        console.log('op :>> ', op);
                                                        obj.validate = true
                                                        answer = true;
                                                        throw Error();
                                                    }
                                                }
                                            }
                                        });
                                    });
                                }
                            });
                        }
                    });
                } catch (error) {}
                if (answer) {
                    list[i].validate = true;
                    goAnchorName = `name${list[i].qid}`
                    result = true;
                    break;
                } else {
                    list[i].validate = false;
                }
            }
        } else {
            // 填空类在不必答的情况下 if有内容需要验证格式
            if (list[i].questionsTypeId == '35' || list[i].questionsTypeId == '34') {
                list[i].optionList.forEach((info) => {
                    info.validate = false
                })
                for (let j in list[i].optionList) {
                    if (list[i].optionList[j].userAnswer == '') {
                        list[i].optionList[j].validate = true;
                        goAnchorName = `name${list[i].qid}`
                        result = true;
                        break;
                    } else {
                        result = Check(list[i].optionList[j]);
                        // console.log('result :>> ', result);
                        if (result) {
                            list[i].optionList[j].validate = true;
                            goAnchorName = `name${list[i].qid}`
                            break;
                        }
                    }
                }
            } else if (inputTypeArr.indexOf(list[i].questionsTypeId) !== -1) {
                if (list[i].userAnswer != '') {
                    result = Check(list[i]);
                    if (result) {
                        goAnchorName = `name${list[i].qid}`
                        list[i].validate = true;
                        break;
                    }
                } else {
                    list[i].validate = false;
                    result = false;
                }
            } else if (list[i].questionsTypeId == '20') {
                let answer = false;
                list[i].userAnswerArr.forEach(info => {
                    if (info.value) {
                        let arr = info.value.split(',');
                        // console.log(arr)
                        // console.log(list[i].maxOptionsNum)
                        if (arr.length < list[i].minOptionsNum || arr.length > list[i].maxOptionsNum) {
                            answer = true;
                        }
                    } else {
                        answer = true;
                    }
                });
                if (answer) {
                    list[i].validate = true;
                    goAnchorName = `name${list[i].qid}`
                    result = true;
                    break;
                } else {
                    list[i].validate = false;
                }
            }
        }
    }
    return {
        goAnchorName,
        result
    };
}


const Transition = (info) => {
    let format = '';
    switch (info.type) {
        case '6':
            format = 5;
            break;
        case '3':
            format = 1;
            break;
        case '24':
            format = 2;
            break;
        case '22':
        case '23':
            format = 3;
            break;
        case '9':
            format = 4;
            break;
        case '18':
            format = 6;
            break;
        case '19':
            format = 7;
            break;
    }
    return format;
}